"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const attribute_title_styles_1 = require("./attribute-title.styles");
const generic_1 = require("../../../../../../generic");
const icons_1 = require("../../../../../../../icons");
const AttributeTitle = ({ label, isAIEnriched }) => {
    const _a = (0, generic_1.useTooltip)(), { onMouseEnter, isOpen, setIsOpen } = _a, tooltipWrapperProps = __rest(_a, ["onMouseEnter", "isOpen", "setIsOpen"]);
    return (react_1.default.createElement(attribute_title_styles_1.StyledAttributeTitleWrapper, null, react_1.default.createElement(generic_1.TooltipWrapper, Object.assign(Object.assign({}, tooltipWrapperProps), { isOpen: isOpen, setIsOpen: setIsOpen, title: label }), react_1.default.createElement("p", { onMouseEnter: onMouseEnter }, label)), isAIEnriched && react_1.default.createElement(icons_1.AISparkleIcon, { fill: ui_components_1.baseColors.blue300 })));
};
exports.default = AttributeTitle;
